const base = '/admin';

export class PsRoutes {
    static HOME = `${base}/`;

    static PASSWORD_RECOVER = `${base}/password/recuperar`;
    static PASSWORD_RESTORE = `${base}/password/restaurar`;

    static PROFILE = `${base}/perfil`;
    static PROFILE_PASSWORD_EDIT = `${base}/perfil/password/actualizar`;
    static NOTIFICATIONS = `${base}/notificaciones`;
    static MESSAGES = `${base}/mensajes`;
    static MESSAGES_DETAIL = `${base}/mensajes/:id/detalle`;

    static CONTRACTORS = `${base}/contratistas`;
    static CONTRACTORS_ADD = `${base}/contratistas/crear`;
    static CONTRACTORS_EDIT = `${base}/contratistas/:id/detalle`;

    static USERS = `${base}/usuarios`;
    static USERS_ADD = `${base}/usuarios/crear`;
    static USERS_DETAIL = `${base}/usuarios/:id/detalle`;

    static MY_CONTRACTORS = `${base}/mis-contratistas`;
    static MY_CONTRACTORS_WORKS = `${base}/mis-contratistas/obras`;
    static MY_CONTRACTORS_WORKS_DETAIL = `${base}/mis-contratistas/obras/:id/detalle`;
    static MY_CONTRACTORS_WORKERS = `${base}/mis-contratistas/mis-trabajadores`;
    static MY_CONTRACTORS_WORKERS_ADD = `${base}/mis-contratistas/mis-trabajadores/crear`;
    static MY_CONTRACTORS_WORKERS_DETAIL = `${base}/mis-contratistas/mis-trabajadores/:workerId/detalle`;
    static MY_CONTRACTORS_MACHINES = `${base}/mis-contratistas/mis-maquinas`;
    static MY_CONTRACTORS_MACHINES_ADD = `${base}/mis-contratistas/mis-maquinas/crear`;
    static MY_CONTRACTORS_MACHINES_DETAIL = `${base}/mis-contratistas/mis-maquinas/:id/detalle`;
    static MY_CONTRACTORS_DOCUMENTS = `${base}/mis-contratistas/documentos`;
    static MY_CONTRACTORS_DOCUMENTS_DETAIL = `${base}/mis-contratistas/:contractorId/documentos/:documentId/detalle`;
    static MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL = `${base}/mis-contratistas/:contractorId/mis-trabajadores/:workerId/documentos/:documentId/detalle`;
    static MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL = `${base}/mis-contratistas/:contractorId/mis-maquinas/:machineId/documentos/:documentId/detalle`;
    static DOCUMENTARY_LIBRARY = `${base}/biblioteca-documental`;
    static DOCUMENTARY_LIBRARY_ADD = `${base}/biblioteca-documental/crear`;
    static MY_OUTSOURCES = `${base}/mis-subcontratas`;
    static MY_OUTSOURCES_ADD = `${base}/mis-subcontratas/crear`;
    static MY_OUTSOURCES_DETAIL = `${base}/mis-subcontratas/:id/detalle`;
    static MY_OUTSOURCES_WORKS = `${base}/mis-subcontratas/mis-obras`;
    static MY_OUTSOURCES_WORKS_ADD = `${base}/mis-subcontratas/mis-obras/crear`;
    static MY_OUTSOURCES_WORKS_DETAIL = `${base}/mis-subcontratas/mis-obras/:id/detalle`;
    static MY_OUTSOURCES_WORKERS = `${base}/mis-subcontratas/trabajadores`;
    static MY_OUTSOURCES_WORKERS_DETAIL = `${base}/mis-subcontratas/:outsourceId/trabajadores/:workerId/detalle`;
    static MY_OUTSOURCES_MACHINES = `${base}/mis-subcontratas/maquinas`;
    static MY_OUTSOURCES_MACHINES_DETAIL = `${base}/mis-subcontratas/:outsourceId/maquinas/:machineId/detalle`;
    static MY_OUTSOURCES_DOCUMENTS = `${base}/mis-subcontratas/documentos`;
    static MY_OUTSOURCES_DOCUMENTS_EXPORT = `${base}/mis-subcontratas/exportar/:id/detalle`;
    static MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM = `${base}/mis-subcontratas/exportar/confirmar`;
    static MY_OUTSOURCES_DOCUMENTS_TYPES = `${base}/mis-subcontratas/documentos/mis-tipos`;
    static MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL = `${base}/mis-subcontratas/documentos/mis-tipos/:id/detalle`;
    static MY_OUTSOURCES_DOCUMENTS_SCHEMES = `${base}/mis-subcontratas/documentos/mis-esquemas`;
    static MY_OUTSOURCES_DOCUMENTS_SCHEMES_DETAIL = `${base}/mis-subcontratas/documentos/mis-esquemas/:id/detalle`;
    static MY_OUTSOURCES_MONTHLY = `${base}/mis-subcontratas/mensual`;
    static MY_OUTSOURCES_TASKS = `${base}/mis-subcontratas/mis-tareas`;
    static MY_OUTSOURCES_TASKS_ADD = `${base}/mis-subcontratas/mis-tareas/crear`;
    static MY_OUTSOURCES_PRESENCES_MONTHLY = `${base}/mis-subcontratas/presencias/mensual`;
    static MY_OUTSOURCES_PRESENCES_WORKS = `${base}/mis-subcontratas/presencias/obras`;
    static MY_OUTSOURCES_PRESENCES_WORKS_DETAIL = `${base}/mis-subcontratas/presencia/obras/:id/detalle`;
    static MY_OUTSOURCES_PAPER_BIN_REMOVE = `${base}/mis-subcontratas/papelera/eliminar`;
    static MY_OUTSOURCES_PAPER_BIN_REMOVE_CONFIRM = `${base}/mis-subcontratas/papelera/eliminar/confirmar`;
    static MY_OUTSOURCES_PAPER_BIN_RECOVER = `${base}/mis-subcontratas/papelera/recuperar`;
    static MY_OUTSOURCES_DOCUMENTS_DETAIL = `${base}/mis-subcontratas/:outsourceId/documentos/:documentId/detalle`;
    static MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL = `${base}/mis-subcontratas/:outsourceId/trabajadores/:workerId/documentos/:documentId/detalle`;
    static MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL = `${base}/mis-subcontratas/:outsourceId/maquinas/:machineId/documentos/:documentId/detalle`;
    static DOCUMENTS_ATTACHMENT = `${base}/documentos/adjuntos`;
    static DOCUMENTS_ATTACHMENT_SUMMARY = `${base}/documentos/adjuntos/resumen`;
}



// WEBPACK FOOTER //
// ./src/app/shared/routing/Routes.js